import { Product } from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export type EditProductRootScreenContextType = {
  refreshProduct: () => Promise<void>;
};

export const EditProductRootScreenContext = React.createContext<
  EditProductRootScreenContextType | undefined
>(undefined);
